(() => {
  const MODAL = document.getElementById('slFilmModal');
  if (!MODAL) return;

  const content = MODAL.querySelector('[data-sl-film-content]');
  const closeEls = MODAL.querySelectorAll('[data-sl-film-close]');

  let lastActiveEl = null;
  let isOpening = false;

  // ✅ Film 페이지 핸들(기본: film)
  const FILM_HANDLE = 'film';

  // ✅ Shopify Markets/언어 루트(/, /en/, /fr/ 등) 자동 대응
  function getRoot() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return root.endsWith('/') ? root : (root + '/');
  }

  // ✅ 테마 에디터 미리보기 파라미터 유지(디자인모드에서 특히 중요)
  function carryPreviewParams(urlObj) {
    try {
      const cur = new URL(window.location.href);
      const keys = ['preview_theme_id', '_fd', 'pb', 'theme_editor'];
      keys.forEach((k) => {
        if (cur.searchParams.has(k) && !urlObj.searchParams.has(k)) {
          urlObj.searchParams.set(k, cur.searchParams.get(k));
        }
      });
    } catch (_) {}
    return urlObj;
  }

  function openModal() {
    lastActiveEl = document.activeElement;
    MODAL.hidden = false;
    MODAL.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sl-modal-open');

    const closeBtn = MODAL.querySelector('.sl-modal__close');
    closeBtn && closeBtn.focus();
  }

  function closeModal() {
    // ✅ 영상 정지(iframe/비디오 제거로 가장 확실)
    content.innerHTML = '';
    MODAL.hidden = true;
    MODAL.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sl-modal-open');

    if (lastActiveEl && typeof lastActiveEl.focus === 'function') lastActiveEl.focus();
  }

  closeEls.forEach((el) => el.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !MODAL.hidden) closeModal();
  });

  // ✅ “popup=1” 이 달린 링크면 Film 모달로 간주 (경로가 /pages/film 이든 /film 이든 OK)
  function isFilmPopupLink(a) {
    try {
      const u = new URL(a.href, window.location.origin);
      const popup = u.searchParams.get('popup');
      if (popup !== '1') return false;

      // film 관련 경로면 OK (pages 누락/언어 prefix 등 변형 허용)
      return u.pathname.includes('film');
    } catch {
      return false;
    }
  }

  // ✅ 항상 올바른 Film 페이지 URL 생성
  function buildFilmPageUrl() {
    const root = getRoot(); // '/', '/en/', ...
    const url = new URL(`${root}pages/${FILM_HANDLE}`, window.location.origin);
    return carryPreviewParams(url);
  }

  async function loadFilmMarkup() {
    const pageUrl = buildFilmPageUrl();

    // 캐시 버스트
    pageUrl.searchParams.set('_ts', String(Date.now()));

    const res = await fetch(pageUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error('Failed to fetch film page HTML');

    const htmlText = await res.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');

    // ✅ 섹션 마커/클래스 기반으로 Film 섹션 찾기 (여러 방식을 순차 시도)
    const filmEl =
      doc.querySelector('[data-sl-film]') ||
      doc.querySelector('section.sl-film') ||
      doc.querySelector('.sl-film') ||
      (doc.querySelector('.sl-film__wrap') ? doc.querySelector('.sl-film__wrap').closest('section, .shopify-section, div') : null);

    if (!filmEl) throw new Error('Film section not found in film page');

    // 안전상 script 제거
    filmEl.querySelectorAll('script').forEach((s) => s.remove());

    return filmEl.outerHTML;
  }

  // 캡처링 단계에서 가로채기(테마 스크립트보다 먼저)
  document.addEventListener(
    'click',
    async (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      if (!isFilmPopupLink(a)) return;

      e.preventDefault();
      if (isOpening) return;
      isOpening = true;

      try {
        content.innerHTML = '<div class="sl-film__placeholder">Loading film…</div>';

        const html = await loadFilmMarkup();
        content.innerHTML = html;
        openModal();
      } catch (err) {
        // ✅ 실패 시에도 “없는 페이지”로 보내지 말고, 올바른 Film 페이지로 안전 이동
        const safe = buildFilmPageUrl();
        safe.searchParams.delete('popup');
        safe.searchParams.delete('_ts');
        window.location.href = safe.toString();
      } finally {
        isOpening = false;
      }
    },
    true
  );
})();
